var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Projects_-_Edit",
    "data-name": "Projects - Edit",
    transform: "translate(-629 -506)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4369",
    "data-name": "Rectangle 4369",
    width: 20,
    height: 20,
    transform: "translate(629 506)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4858",
    "data-name": "Group 4858",
    transform: "translate(304.15 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M414.31,61.371l2.228-2.228,3.306,3.306-2.228,2.228Z",
    transform: "translate(-77.38 384.857)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M129.671,144.464l-.525,3.831,3.831-.525,9.09-9.09-3.306-3.306Z",
    transform: "translate(197.703 311.321)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsEdit);
export default __webpack_public_path__ + "static/media/Projects - Edit.2f76f3223923fffbc086a72e9981878a.svg";
export { ForwardRef as ReactComponent };